import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  OIDN: undefined,
  vdabReferentie: undefined,
  useJobApplicationLocation: false,
};

const vacancy = createSlice({
  name: 'vacancy',
  initialState,
  reducers: {
    setVacancy: (state, action) => {
      if (action.payload?.vdabReferentie) state.vdabReferentie = action.payload?.vdabReferentie;
      if (action.payload?.OIDN) state.OIDN = action.payload?.OIDN;
    },
    resetVacancy: (state) => {
      state.OIDN = undefined;
      state.vdabReferentie = undefined;
    },
    setUseJobApplicationLocation: (state, action) => {
      state.useJobApplicationLocation = action.payload;
    },
  },
});

export const {
  resetVacancy,
  setVacancy,
  setUseJobApplicationLocation,
} = vacancy.actions;

export default vacancy.reducer;
